import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import SectionTitle from "@/components/base/SectionTitle";

const teamStats = [
  { value: "1200万+", label: "月均访问用户" },
  { value: "18万+", label: "累计资讯内容" },
  { value: "7×24", label: "小时热点跟进" },
  { value: "30+", label: "覆盖娱乐领域" },
];

const services = [
  {
    icon: "ri-newspaper-line",
    title: "娱乐新闻聚合",
    desc: "全网聚合最新娱乐新闻，第一时间呈现官方动态、行业风向与热点话题。",
  },
  {
    icon: "ri-chat-smile-2-line",
    title: "明星八卦追踪",
    desc: "客观梳理明星生活与情感相关资讯，帮助读者理性看待每一条爆料。",
  },
  {
    icon: "ri-movie-2-line",
    title: "影视音乐报道",
    desc: "覆盖剧集、电影与音乐作品的动态，带来票房、口碑与现场的鲜活内容。",
  },
  {
    icon: "ri-flashlight-line",
    title: "独家爆料整理",
    desc: "通过公开渠道与编辑部整理重磅爆料，为用户提供更快速的资讯参考。",
  },
];

export default function AboutPage() {
  return (
    <Layout>
      {/* Hero */}
      <section className="relative w-full h-[300px] md:h-[420px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20media%20newsroom%20with%20large%20screens%20and%20warm%20orange%20lighting%2C%20stylized%20editorial%20graphic%20illustration%2C%20orange%20and%20amber%20tones%2C%20professional%20atmosphere&width=1600&height=700&seq=about-hero-2026&orientation=landscape"
          alt="吃瓜爆料网编辑部"
          title="吃瓜爆料网 - 关于我们"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/90 via-secondary-950/60 to-secondary-950/30" />
        <div className="absolute inset-0">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 h-full flex flex-col justify-center">
            <span className="inline-block self-start px-3 py-1 rounded-md bg-accent-500 text-secondary-950 text-xs font-medium mb-3">
              关于我们
            </span>
            <h1 className="text-3xl md:text-5xl font-black text-background-50 leading-tight max-w-2xl">
              做最懂娱乐圈的资讯伙伴
            </h1>
            <p className="mt-4 text-sm md:text-base text-background-200 max-w-2xl leading-relaxed">
              吃瓜爆料网是一家专注于娱乐资讯的现代门户网站，聚合最新娱乐新闻、明星八卦、影视音乐综艺动态与独家爆料，为关注娱乐圈的用户提供快速、全面、可信赖的信息参考。
            </p>
          </div>
        </div>
      </section>

      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        {/* Stats */}
        <section className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {teamStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg bg-background-50 border border-background-200 p-5 text-center"
            >
              <p className="text-2xl md:text-3xl font-black text-primary-600">{stat.value}</p>
              <p className="mt-1.5 text-xs md:text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </section>

        {/* Positioning */}
        <section className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="rounded-lg overflow-hidden bg-background-200 aspect-[16/11]">
            <img
              src="https://readdy.ai/api/search-image?query=creative%20editorial%20team%20working%20with%20laptops%20and%20screens%20in%20a%20warm%20modern%20office%2C%20stylized%20editorial%20illustration%2C%20orange%20and%20amber%20tones%2C%20lively%20professional%20mood&width=1000&height=700&seq=about-team-2026&orientation=landscape"
              alt="吃瓜爆料网团队"
              title="吃瓜爆料网团队 - 关于我们"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <SectionTitle title="网站定位" icon="ri-focus-3-line" />
            <p className="text-sm md:text-base text-foreground-700 leading-7">
              我们相信，娱乐资讯不只是热闹的谈资，更是许多人了解世界、放松生活的方式。吃瓜爆料网致力于以更清晰的结构、更及时的更新和更友好的阅读体验，把纷繁复杂的娱乐信息整理成易读易找的内容。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-7">
              网站围绕“快速浏览、精准查找、深入了解”三大核心需求设计，通过分类、频道、筛选、搜索与相关推荐，帮助用户高效获取关心的话题。我们坚持理性客观，呼吁读者在享受资讯的同时保持独立思考。
            </p>
          </div>
        </section>

        {/* Services */}
        <section className="mt-10 md:mt-14">
          <SectionTitle title="业务范围" subtitle="我们提供的核心内容与服务" icon="ri-briefcase-4-line" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {services.map((service) => (
              <div
                key={service.title}
                className="rounded-lg bg-background-50 border border-background-200 p-5 hover:border-primary-300 transition-colors"
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 text-2xl">
                  <i className={service.icon} />
                </span>
                <h3 className="mt-4 font-bold text-foreground-950">{service.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{service.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Team */}
        <section className="mt-10 md:mt-14">
          <SectionTitle title="团队介绍" subtitle="一群热爱内容与资讯的人" icon="ri-team-line" />
          <div className="rounded-lg bg-background-50 border border-background-200 p-6 md:p-8">
            <p className="text-sm md:text-base text-foreground-700 leading-7">
              吃瓜爆料网由一支兼具内容编辑与产品思维的年轻团队运营。我们中有深耕娱乐报道多年的资深编辑，也有擅长信息整理与产品设计的技术伙伴。团队坚持“内容为王、体验优先”的价值观，力求每一条资讯都清晰、准确、易读。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              {["内容编辑部", "热点跟进组", "产品与设计组", "用户运营组"].map((dept) => (
                <span
                  key={dept}
                  className="px-4 py-2 rounded-full bg-secondary-100 text-secondary-800 text-sm"
                >
                  {dept}
                </span>
              ))}
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="mt-10 md:mt-14 rounded-lg bg-secondary-900 p-6 md:p-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <h2 className="text-xl md:text-2xl font-black text-background-50">
              有新闻线索或合作意向？
            </h2>
            <p className="mt-2 text-sm md:text-base text-background-200 max-w-2xl leading-relaxed">
              欢迎通过联系页面留下你的想法，无论是提供爆料线索、内容合作还是反馈建议，我们都会认真阅读。
            </p>
          </div>
          <Link
            to="/contact"
            className="shrink-0 h-11 px-7 inline-flex items-center justify-center gap-2 rounded-full bg-accent-500 text-secondary-950 text-sm font-bold hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-send-plane-fill" />
            前往联系我们
          </Link>
        </section>
      </div>
    </Layout>
  );
}